// Mock data for Britedge demo
export const mockUser = {
  id: 'usr_001',
  firstName: 'Adewale',
  lastName: 'Johnson',
  email: 'adewale.j@example.com',
  phone: '+234 801 234 5678',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Adewale',
  walletBalance: 125450.50,
  accountNumber: '2047856321',
  bvn: '22345678901',
  tier: 'Gold',
  joinDate: '2024-01-15'
};

export const mockTransactions = [
  { id: 'txn_001', type: 'credit', amount: 50000, description: 'Transfer from Chioma Obi', date: '2024-12-20T10:30:00', status: 'completed', category: 'transfer' },
  { id: 'txn_002', type: 'debit', amount: 5000, description: 'MTN Airtime Purchase', date: '2024-12-20T09:15:00', status: 'completed', category: 'airtime' },
  { id: 'txn_003', type: 'debit', amount: 12500, description: 'DSTV Premium Subscription', date: '2024-12-19T18:45:00', status: 'completed', category: 'bills' },
  { id: 'txn_004', type: 'credit', amount: 25000, description: 'Salary Payment', date: '2024-12-19T08:00:00', status: 'completed', category: 'salary' },
  { id: 'txn_005', type: 'debit', amount: 3500, description: 'Electricity Bill - EKEDC', date: '2024-12-18T14:20:00', status: 'completed', category: 'bills' },
  { id: 'txn_006', type: 'debit', amount: 15000, description: 'Transfer to Tunde Bakare', date: '2024-12-18T11:00:00', status: 'completed', category: 'transfer' },
  { id: 'txn_007', type: 'credit', amount: 8000, description: 'Refund - Online Purchase', date: '2024-12-17T16:30:00', status: 'completed', category: 'refund' },
  { id: 'txn_008', type: 'debit', amount: 2000, description: 'Glo Data Bundle', date: '2024-12-17T13:45:00', status: 'completed', category: 'data' }
];

export const mockSavings = [
  { id: 'sav_001', name: 'New Car Fund', target: 5000000, current: 1250000, startDate: '2024-01-01', endDate: '2025-12-31', frequency: 'monthly', nextContribution: 150000, color: '#0066FF' },
  { id: 'sav_002', name: 'Emergency Fund', target: 500000, current: 380000, startDate: '2024-03-15', endDate: '2024-12-31', frequency: 'weekly', nextContribution: 20000, color: '#FF3B30' },
  { id: 'sav_003', name: 'Vacation to Dubai', target: 1500000, current: 450000, startDate: '2024-06-01', endDate: '2025-06-01', frequency: 'monthly', nextContribution: 100000, color: '#34C759' }
];

export const mockLoans = [
  { id: 'loan_001', type: 'Personal Loan', amount: 200000, balance: 120000, monthlyPayment: 20000, dueDate: '2025-01-05', status: 'active', interestRate: 5.5, startDate: '2024-06-01', endDate: '2025-06-01' },
  { id: 'loan_002', type: 'Business Loan', amount: 500000, balance: 0, monthlyPayment: 0, dueDate: null, status: 'completed', interestRate: 7.0, startDate: '2023-12-01', endDate: '2024-11-30' }
];

export const mockCooperatives = [
  { 
    id: 'coop_001', 
    name: 'Office Friends Esusu', 
    type: 'rotating', 
    members: 8, 
    contributionAmount: 50000, 
    frequency: 'monthly', 
    nextPayout: '2025-01-10',
    myTurn: 4,
    totalPool: 400000,
    avatar: 'https://api.dicebear.com/7.x/identicon/svg?seed=office',
    status: 'active'
  },
  { 
    id: 'coop_002', 
    name: 'Family Goal Saving', 
    type: 'target', 
    members: 12, 
    contributionAmount: 25000, 
    frequency: 'weekly', 
    nextPayout: '2025-03-15',
    target: 3000000,
    currentAmount: 1800000,
    avatar: 'https://api.dicebear.com/7.x/identicon/svg?seed=family',
    status: 'active'
  },
  { 
    id: 'coop_003', 
    name: 'Market Women Ajo', 
    type: 'rotating', 
    members: 20, 
    contributionAmount: 10000, 
    frequency: 'weekly', 
    nextPayout: '2024-12-27',
    myTurn: 15,
    totalPool: 200000,
    avatar: 'https://api.dicebear.com/7.x/identicon/svg?seed=market',
    status: 'active'
  }
];

export const mockBanks = [
  'Access Bank', 'GTBank', 'First Bank', 'UBA', 'Zenith Bank', 'Fidelity Bank', 
  'Sterling Bank', 'Wema Bank', 'Union Bank', 'Polaris Bank', 'Ecobank', 'Stanbic IBTC'
];

export const mockBillers = {
  electricity: ['EKEDC', 'IKEDC', 'AEDC', 'PHED', 'JED', 'IBEDC', 'KAEDCO'],
  tv: ['DSTV', 'GOtv', 'Startimes', 'Showmax'],
  internet: ['Spectranet', 'Smile', 'Swift', 'Coollink', 'ipNX'],
  airtime: ['MTN', 'Glo', 'Airtel', '9mobile'],
  data: ['MTN', 'Glo', 'Airtel', '9mobile']
};

export const mockCards = [
  { id: 'card_001', type: 'virtual', last4: '4521', brand: 'Mastercard', expiryDate: '12/26', status: 'active', balance: 25000 },
  { id: 'card_002', type: 'physical', last4: '8934', brand: 'Visa', expiryDate: '08/27', status: 'active', balance: 50000 }
];

export const mockBudgets = [
  { category: 'Food', allocated: 80000, spent: 45000, color: '#34C759' },
  { category: 'Transport', allocated: 40000, spent: 35000, color: '#0066FF' },
  { category: 'Entertainment', allocated: 30000, spent: 28000, color: '#FF3B30' },
  { category: 'Bills', allocated: 50000, spent: 38000, color: '#FF9500' },
  { category: 'Shopping', allocated: 60000, spent: 42000, color: '#AF52DE' }
];

// Helper function to format currency
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 2
  }).format(amount);
};

// Helper function to format date
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-NG', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
};

// Helper function to get initials
export const getInitials = (firstName, lastName) => {
  return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();
};
